export const routeNames = Object.freeze({
  ACCOUNT_DETAILS_VIEW: "ACCOUNT_DETAILS_VIEW",
  ADDRESS_BOOK: "ADDRESS_BOOK",
  APP_PREFERENCES: "APP_PREFERENCES",
  BUSINESS_ONBOARDING_VIEW: "BUSINESS_ONBOARDING_VIEW",
  CARDS_FOR_ACCOUNT: "CARDS_FOR_ACCOUNT",
  CARDS_NEW: "CARDS_NEW",
  CARD_DETAILS: "CARD_DETAILS",
  CUSTOMER_ERROR_VIEW: "ERROR_VIEW",
  FINANCIAL_OVERVIEW: "FINANCIAL_OVERVIEW",
  HOME: "HOME",
  INTERNET_BANKING_SETTINGS: "INTERNET_BANKING_SETTINGS",
  BUSINESS_USERS: "BUSINESS_USERS",
  LOAN_APPLICATION: "LOAN_APPLICATION",
  LOAN_APPLICATIONS: "LOAN_APPLICATIONS",
  LOAN_APPLICATION_SPLASH: "LOAN_APPLICATION_SPLASH",
  LOAN_CALCULATORS: "LOAN_CALCULATORS",
  MESSAGES: "MESSAGES",
  ONBOARDING_COMPLETED_VIEW: "ONBOARDING_COMPLETED_VIEW",
  ONBOARDING_SPLASH: "ONBOARDING_SPLASH",
  ONBOARDING_VIEW: "ONBOARDING_VIEW",
  OPEN_ACCOUNT: "OPEN_ACCOUNT",
  PAGE_NOT_FOUND: "PAGE_NOT_FOUND",
  PAYMENT_VIEW: "PAYMENT_VIEW",
  PAY_ID_MANAGE: "PAY_ID_MANAGE",
  PAY_ID_REGISTER: "PAY_ID_REGISTER",
  PRODUCT_LED_ONBOARDING_VIEW: "PRODUCT_LED_ONBOARDING_VIEW",
  PRODUCT_LED_ONBOARDING_CTA_VIEW: "PRODUCT_LED_ONBOARDING_CTA_VIEW",
  REQUIRES_ONBOARDING_VIEW: "REQUIRES_ONBOARDING_VIEW",
  SECURITY_VIEW: "SECURITY_VIEW",
  SIGN_IN_ERROR: "SIGN_IN_ERROR",
  SIGN_IN_VIEW: "SIGN_IN_VIEW",
  SIGN_UP_VIEW: "SIGN_UP_VIEW",
  THEME_MANAGER: "THEME_MANAGER",
  TRANSFER_VIEW: "TRANSFER_VIEW",
  UPDATE_MOBILE_NUMBER: "UPDATE_MOBILE_NUMBER",
  USER_PROFILE: "USER_PROFILE",
  BROKER_LOAN_APPLICATIONS: "BROKER_LOAN_APPLICATIONS",
  BROKER_LOAN_APPLICATION: "BROKER_LOAN_APPLICATION",
});
